module.exports = __webpack_public_path__ + "static/media/pdf.1fa46014.pdf";